const _difference = async (a1, a2) => {
    let a2Set = new Set(a2);
    return a1.filter(function (x) { return !a2Set.has(x); });
}

// retorna elementos diferentes entre dois arrays
export const arrayDiference = async (arrayA, arrayB) => {
    return _difference(arrayA, arrayB).concat(_difference(arrayB, arrayA))
}

// retorna elementos iguais entre dois arrays
export const arrayInterseccao = async (arrayA, arrayB) => {
    return arrayA.filter(x => arrayB.includes(x))
}

// converte data
export const convertDateIsoToDate = async (date, format = false) => {
    let newDate = ''
    if (format === false) {
        newDate = new Date(
            date.substring(0, 4),
            date.substring(5, 7) - 1,
            date.substring(8, 10),
            date.substring(11, 13),
            date.substring(14, 16),
            date.substring(17, 19)
        )
    } else {
        newDate = `${date.substring(8, 10)}/${date.substring(5, 7)}/${date.substring(0, 4)}`
    }
    return newDate
}

export const formatarData = (value) => {
    if (value) {
        const data = new Date(value);
        return data.toLocaleDateString('pt-BR', { timeZone: 'UTC' });
    }
}

export const retornarStatusContrato = (valor) => {
    switch (valor) {
        case 2:
            return 'Ativo';
        case 3:
            return 'Inativo';
        default:
            return 'Pendente';
    }
}

export const validarCNPJ = (cnpj) => {

    cnpj = cnpj.replace(/[^\d]+/g, '');

    if (cnpj == '') return false;

    if (cnpj.length != 14)
        return false;

    // Elimina CNPJs invalidos conhecidos
    if (cnpj == "00000000000000" ||
        cnpj == "11111111111111" ||
        cnpj == "22222222222222" ||
        cnpj == "33333333333333" ||
        cnpj == "44444444444444" ||
        cnpj == "55555555555555" ||
        cnpj == "66666666666666" ||
        cnpj == "77777777777777" ||
        cnpj == "88888888888888" ||
        cnpj == "99999999999999")
        return false;

    // Valida DVs
    let tamanho = cnpj.length - 2
    let numeros = cnpj.substring(0, tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
            pos = 9;
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(0))
        return false;

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
            pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(1))
        return false;

    return true;

}


